import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import successImage from 'assets/images/success-image.svg'
import DateUtil from 'utils/DateUtil'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import ReservationModalWrapper from 'components/home/on-campus-services/gym/gym-list/personal/reservation-scheduler/ReservationModal'
import NotificationDialog from 'components/ui/NotificationDialog'
import { IFilteredGymSalonList } from 'types/GymType'
import GymService from 'service/GymService'
import LoadingWrapper from './LoadingWrapper'

/* filtered date - default */
const today = DateUtil.getStartOfDay(new Date())

interface CompProps {
  id: number
  locationId: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function GymSalonRes({ locationId, id, setReservationType }: CompProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)
  const [loading, setLoading] = useState(false)
  const [salonList, setSalonList] = useState<IFilteredGymSalonList[] | undefined>(undefined)

  const openModal = () => setModal(true)
  const closeModal = (resetRes = false) => {
    setModal(false)
    if (resetRes) setReservationType(0, undefined)()
  }
  const closeNotification = () => {
    setNotification(false)
    setReservationType(0, undefined)()
  }

  /* Get Gym Saloon (Personal) list */
  const getGymSalonList = () => {
    setLoading(true)
    GymService.getFilteredGymSalonList<IFilteredGymSalonList>({
      inventoryIdList: [],
      gymServiceId: 0,
      isEmployeeLocation: false,
      isIncludeNotActives: false,
      locationId: locationId,
      reservationDate: today,
    })
      .then((res) => setSalonList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    getGymSalonList()
    openModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])
  const selectedSalon = salonList?.find((r) => r.id === id)

  if (loading) return <LoadingWrapper />

  return (
    <>
      {/* Gym Salon Reservation Scheduler Modal */}
      {!!selectedSalon ? (
        <ReservationModalWrapper
          open={modal}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          selectedSalon={selectedSalon}
          filterDate={today}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('gym-res-modal.notification-title')}
        content={t('gym-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
